<div class="ibox-content">
  <form [formGroup]="form">
    <div class="form-group row">
      <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
      <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
    </div>
    <div class="row" hidden="true">
      <input formControlName="id" name="id" type="text" class="form-control" />
      <input formControlName="personal" name="personal" type="text" class="form-control" />
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label font-bold" for="fecha">Fecha</label>
        <div class="fechaC">
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fecha" dateFormat="dd/mm/yy" inputId="fecha" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
          <div *ngIf="registerFormControl.fecha.errors?.required && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">La Fecha es Requerida</div>
          <mat-error *ngIf="desdeAnterior && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">
            No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
          </mat-error>
          <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.fecha?.dirty || registerFormControl.fecha?.touched || submitted)" class="text-danger">
            No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
          </mat-error>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class=" col-form-label font-bold">Quincena</label>
          <input formControlName="quincena" maxlength="1" name ="selectedQuincena" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.quincena.errors && (registerFormControl.quincena?.dirty || registerFormControl.quincena?.touched || submitted)}"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label class="col-form-label font-bold">Código Nómina</label>
        <div>
          <comboTools [list]=codigosNominaList
                      selected='codigosNomina'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Código Nómina'
                      (SelectedChange)="onChangeCodigoNomina($event)">
          </comboTools>
          <div *ngIf="registerFormControl.codigosNomina.invalid && (
               registerFormControl.codigosNomina?.dirty || registerFormControl.codigosNomina?.touched || submitted)" class="text-danger">
            Código Nómina es Requerido
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class=" col-form-label font-bold">Motivo</label>
          <input formControlName="motivo" maxlength="50" name ="selectedMotivo" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.motivo.errors && (registerFormControl.motivo?.dirty || registerFormControl.motivo?.touched || submitted)}"/>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="tipoCarga != 2 && tipoCarga != 4">
      <div class="col-md-6">
        <div class="form-group">
          <label class=" col-form-label font-bold">Importe</label>
          <input formControlName="importe" name ="selectedImporte" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.importe.errors && (registerFormControl.importe?.dirty || registerFormControl.importe?.touched || submitted)}"/>
          <mat-error  class="text-danger"*ngIf="registerFormControl.importe.errors?.required && (registerFormControl.importe?.dirty || registerFormControl.importe?.touched || submitted)">
              El Importe es Requerido
          </mat-error>
        </div>
        <!-- <app-input-numeric [inputNumericFormControl]="form" [ValidarRequerido]="true" placeHolderValue="Importe" [actualizarFormato]="actualizarFormatoInputNumerico"></app-input-numeric> -->
      </div>
      <div class="col-md-6">
        <label class="col-form-label font-bold">Moneda</label>
        <div>
          <comboTools [list]=monedasList
                      selected='moneda'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Moneda'></comboTools>
          <div *ngIf="registerFormControl.moneda.invalid && (
               registerFormControl.moneda?.dirty || registerFormControl.moneda?.touched || submitted)" class="text-danger">
            Moneda es Requerido
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" *ngIf="tipoCarga != 1 && tipoCarga != 4">
        <div class="form-group">
          <label class=" col-form-label font-bold">Cantidad</label>
          <input formControlName="cantidad" name ="selectedCantidad" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.cantidad.errors && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)}"/>
          <mat-error  class="text-danger"*ngIf="registerFormControl.cantidad.errors?.required && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)">
              La Cantidad es Requerida
          </mat-error>
        </div>
      </div>
      <div class="col-md-6">
        <label class="col-form-label font-bold">Unidad Medida</label>
        <div>
          <comboTools [list]=unidadesList
                      selected='unidadMedida'
                      [formParent]="form"
                      [isEditing]=true
                      filter="descripcion"
                      ph='Unidad Medida'></comboTools>
          <div *ngIf="registerFormControl.unidadMedida.invalid && (
               registerFormControl.unidadMedida?.dirty || registerFormControl.unidadMedida?.touched || submitted)" class="text-danger">
            Unidad medida es requerido
          </div>
        </div>
      </div>
    </div>
    
  </form>
</div>

